import React, { FC, Fragment } from 'react'
import { BlogItem } from '__generated__/sanity'
import { CbDualImage } from './blocks/dual-image'
import { CbSingleImage } from './blocks/single-image'
import { CbRichContent } from './blocks/rich-content'
import { CbImageWithText } from './blocks/CbImageWithText'
import { CbCta } from './blocks/CbCta'
import { CbVideo } from './blocks/CbVideo'

/**
 * TODO:
 * [x] Blog intro block
 * [x] Hero
 * [x] Image size, backdrop & caption to Image
 * [x] Gradient text style
 * [x] Check bullet list
 * [x] Image + Text left/right
 * [] CTA
 * [] Video player large/small
 */

type ContentBlocksProps = {
  blocks: BlogItem['fields']['richContent']['items']
}

export const ContentBlocks: FC<ContentBlocksProps> = ({ blocks }) => {
  if (blocks.length === 0) {
    return null
  }
  return (
    <>
      {blocks.map((block, index) => {
        switch (block._type) {
          case 'cbSingleImage':
            return (
              <Fragment key={index}>
                <CbSingleImage {...block} />
              </Fragment>
            )
          case 'cbDualImage':
            return (
              <Fragment key={index}>
                <CbDualImage {...block} />
              </Fragment>
            )
          case 'cbRichContent':
            return (
              <Fragment key={index}>
                <CbRichContent {...block} />
              </Fragment>
            )
          case 'cbImageWithText':
            return (
              <Fragment key={index}>
                <CbImageWithText {...block} />
              </Fragment>
            )
          case 'cbCta':
            return (
              <Fragment key={index}>
                <CbCta {...block} />
              </Fragment>
            )
          case 'cbVideo':
            return (
              <Fragment key={index}>
                <CbVideo {...block} />
              </Fragment>
            )
          default:
            return null
        }
      })}
    </>
  )
}
